module.exports = __webpack_public_path__ + "img/pauli-x-root-15.9615945b.svg";